import { I } from "@/components/kamibot-v2/discord";
import { Container, SectionHead } from "@/components/kamibot-v2/common";

export function Trust() {
  return (
    <section className="trust">
      <Container>
        <SectionHead
          eyebrow="TRUST"
          title="매일, 많은 한국어 디스코드 서버에서."
          sub="한 사람이 직접 만들고 직접 운영해요. 그래서 손이 닿는 만큼, 데이터도 권한도 작게 다뤄요."
        />
        <div className="trust-cards trust-cards-4">
          <div className="trust-card">
            <span className="ic">
              <I.user />
            </span>
            <b>한 사람이 만들고 운영해요</b>
            <span>
              1인 개발자가 코드부터 응대까지 직접 해요. 의사결정이 빠르고, 사용자 한 분 한 분이 보여요.
            </span>
          </div>
          <div className="trust-card">
            <span className="ic">
              <I.verified />
            </span>
            <b>Discord 인증된 봇</b>
            <span>
              디스코드의 검수를 통과한 인증 봇이에요. 보안·권한 정책을 디스코드와 같이 지켜요.
            </span>
          </div>
          <div className="trust-card">
            <span className="ic">
              <I.eye_off />
            </span>
            <b>개인정보를 받지 않아요</b>
            <span>
              이메일, 이름, 전화번호 같은 건 묻지 않아요. 디스코드 ID 외에 따로 회원가입을 받지 않아요.
            </span>
          </div>
          <div className="trust-card">
            <span className="ic">
              <I.database />
            </span>
            <b>저장 데이터는 암호화돼요</b>
            <span>
              서버 설정처럼 꼭 필요한 데이터만 저장하고, 모두 디스크 단에서 암호화해서 보관해요.
            </span>
          </div>
        </div>
      </Container>
    </section>
  );
}
